<fieldset v-if="showProfileAttributes" class="tt-shopper-profile-fieldset">
  <template v-if="showCustomAttributes" v-for="(customAttr, i) in customAttributes">
    <tt-selectbox v-if="customAttr.type === SINGLE_SELECT_TYPE"
      v-model="profileValues.customAttributes[i].valueDefinitionId"
      :id="'tt-profile-attr-' + customAttr.id"
      class="tt-shopper-profile-fieldset__custom-attribute"
      :errorText="profileErrors.customAttributes[customAttr.id]"
      :label="customAttr.label"
      :name="'tt-profile-attr-' + customAttr.id"
      :selectOneText="$msg('profileForm.selectOne')"
      :options="customAttributeValueDefinitions[customAttr.id]"
      :required="customAttr.required">
    </tt-selectbox>
    <tt-text-field v-if="customAttr.type === FREE_FORM_TEXT_TYPE"
      v-model="profileValues.customAttributes[i].freeFormText"
      :id="'tt-profile-attr-' + customAttr.id"
      class="tt-shopper-profile-fieldset__custom-attribute"
      :errorText="profileErrors.customAttributes[customAttr.id]"
      :label="customAttr.label"
      name="'tt-profile-attr-' + customAttr.id"
      :required="customAttr.required">
    </tt-text-field>
    <tt-check-group v-if="customAttr.type === MULTI_SELECT_TYPE"
      v-model="profileValues.customAttributes[i].value"
      :id="'tt-profile-attr-' + customAttr.id" 
      class="tt-shopper-profile-fieldset__custom-attribute"
      :displayType="customAttr.displayAsTags == true ? 'tag' : 'checkbox'"
      :errorText="profileErrors.customAttributes[customAttr.id]"
      :fields="customAttributeValueDefinitions[customAttr.id]"
      :groupName="'tt-profile-attr-' + customAttr.id"
      :label="customAttr.label" 
      :required="customAttr.required">
    </tt-check-group>
  </template>
  <tt-selectbox v-if="ageRange"
    v-model="profileValues.ageRange"
    id="tt-profile-age-range"
    class="tt-shopper-profile-fieldset__age-range"
    :errorText="profileErrors.ageRange"
    :label="$msg('profileForm.ageRange')"
    name="tt-profile-age-range"
    :selectOneText="$msg('profileForm.selectOne')"
    :options="ageRanges"
    :required="ageRange.required">
  </tt-selectbox>
    <tt-selectbox v-if="location"
    v-model="profileValues.country"
    id="tt-profile-country"
    class="tt-shopper-profile-fieldset__country"
    :errorText="profileErrors.country"
    :label="$msg('profileForm.country')"
    name="tt-profile-country"
    :selectOneText="$msg('profileForm.selectOne')"
    :options="countries"
    :required="location.required">
  </tt-selectbox>
  <tt-selectbox v-if="location && stateOptions"
    v-model="profileValues.state"
    id="tt-profile-state"
    class="tt-shopper-profile-fieldset__state"
    :errorText="profileErrors.state"
    :label="stateOrProvinceLabel"
    name="tt-profile-state"
    :selectOneText="$msg('profileForm.selectOne')"
    :options="stateOptions"
    :required="location.required">
  </tt-selectbox>
  <tt-text-field v-if="location && !stateOptions"
    v-model="profileValues.state"
    id="tt-profile-state"
    class="tt-shopper-profile-fieldset__state"
    :errorText="profileErrors.state"
    :label="$msg('profileForm.stateProvinceRegion')"
    name="tt-profile-state"
    :required="location.required">
  </tt-text-field>
  <tt-text-field v-if="location"
    v-model="profileValues.city"
    id="tt-profile-city"
    class="tt-shopper-profile-fieldset__city"
    :errorText="profileErrors.city"
    :label="$msg('profileForm.city')"
    name="tt-profile-city"
    :required="location.required">
  </tt-text-field>
</fieldset>